import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { translations } from '../translations';
import './MSCs.css';

// Bulgarian content definitions
const bgContentChunks = [
  {
    id: 1,
    title: "Какво са екзозомите",
    subtitle: "Регенерация. Устойчивост. Обновление. Подмладяване на клетките.",
    fullText: "ExosomesMSC(мезенхимни стволови клетки от пъпна връв)\nЕкзозомите са малки мембранни везикули, получени от мезенхимни стволови клетки и съществуват естествено в кръвта и телесните ни тъкани. Вътрешните везикули се образуват чрез пъпкуване навътре в клетъчни отделения, известни като мултивезикуларни ендозоми (MVE). Когато MVE се слее с плазмената мембрана, тези вътрешни везикули се освобождават като екзозоми, като могат да пътуват до отдалечените тъкани, за да повлияят на различни аспекти на клетъчното поведение и физиология. Екзозомите имат множество предимства като например увеличаване на синтеза на колаген, успокояване на възпалението и неутрализиране на свободните радикали, които могат да увредят клетките. Те се насочват към наранените или стареещите клетки, с цел да ги възстановят, което означава, че ползите им също се простират до регенерация на космените фоликули и тъканите или за подмладяване на кожата.\nТози напредък в изследването на екзозомите без съмнение дава тласък и в еволюцията на естетичните процедури и красотата, тъй като техните регенеративни способности са доказано по-големи от възможностите на всички останали методи, апаратни или инжекционни, които са налични на пазара към момента.",
    shortText: "Екзозомите са малки везикули от мезенхимни стволови клетки, които съществуват естествено в човешкото тяло. Те имат способността да стимулират регенерацията, увеличават колагена и успокояват възпалението. Тези иновативни решения предлагат по-ефективни възможности от традиционните методи за подмладяване.",
    summaryText: "Екзозомите са малки везикули от мезенхимни стволови клетки с регенеративни свойства. Те увеличават синтеза на колаген и успокояват възпалението. Прилагат се за подмладяване и възстановяване на тъкани.",
    icon: "🧬"
  },
  {
    id: 2,
    title: "С какво са по-различни MUSE MSC (Stem Cells)?",
    subtitle: "MuseCells (Multi-lineage differentiating stress enduring cells) са ендогенни, неракови, плурипотентни стволови клетки.",
    fullText: "Тези клетки се намират във връзките на почти всеки орган, включително пъпната връв, костния мозък и периферната кръв. Освен това, те могат да бъдат събирани от комерсиално достъпни мезенхимни клетки като човешки фибробласти, мезенхимни стволови клетки от костен мозък и стволови клетки, произхождащи от мастна тъкан. Интригуващото при Muse Cells е тяхната способност да генерират клетки, представляващи всички три зародишни слоя от единична клетка, както спонтанно, така и под влиянието на цитокини. Те изразяват гени за плурипотентност и се характеризират със способността си за триплобластична диференциация, която се подновява през поколенията.",
    shortText: "MUSE клетките са уникални плурипотентни стволови клетки, които се намират в различни органи. Те притежават способността да се превръщат в клетки от всички три зародишни слоя. Тази характеристика ги прави изключително ценни за регенеративната медицина.",
    summaryText: "MUSE клетките са плурипотентни стволови клетки намиращи се в различни органи. Те могат да генерират клетки от всички три зародишни слоя. Имат огромен потенциал за регенеративна медицина.",
    icon: "🔬"
  },
  {
    id: 3,
    title: "Екзозомите, извлечени от Muse MSC",
    subtitle: "multilineage-differentiating stress-enduring - мезенхимни стволови клетки",
    fullText: "Предлагат революционен подход в областта на регенеративната медицина и терапията на различни заболявания. Благодарение на уникалната способност на Muse MSC (Stem Cells) да се диференцират в множество клетъчни линии и да издържат на стресови условия, техните екзозоми са обогатени със специфични нуклеинови киселини, протеини, липиди и метаболити, които могат да помогнат за възстановяването и регенерацията на увредени тъкани, модулирането на имунната система и подобряването на междуклетъчната комуникация. Това ги прави особено ценни за разработването на нови терапевтични стратегии за лечение на широк спектър от медицински състояния:",
    shortText: "Екзозомите от MUSE клетки предлагат революционни терапевтични възможности за множество заболявания. Те съдържат специфични биоактивни молекули, които възстановяват тъканите и модулират имунитета. Използват се за лечение на хронични заболявания, възпаления, травми и анти-ейдж терапия.",
    summaryText: "Екзозомите от MUSE клетки съдържат биоактивни молекули с терапевтичен потенциал. Те възстановяват тъкани и модулират имунитета. Прилагат се при множество заболявания и анти-ейдж терапия.",
    icon: "💎",
    applications: [
      "Хронични заболявания",
      "Възпалителни състояния", 
      "Травми",
      "Косопад",
      "Грижа за кожата и анти-ейдж терапия"
    ]
  }
];

// English content definitions
const enContentChunks = [
  {
    id: 1,
    title: "What are exosomes?",
    subtitle: "Regeneration. Resilience. Renewal. Cellular Rejuvenation.",
    fullText: "ExosomesMSC (mesenchymal stem cells from umbilical cord)\nExosomes are small membrane vesicles derived from mesenchymal stem cells that exist naturally in our blood and body tissues. Internal vesicles are formed by inward budding into cellular compartments known as multivesicular endosomes (MVE). When MVE fuses with the plasma membrane, these internal vesicles are released as exosomes, which can travel to distant tissues to influence various aspects of cellular behavior and physiology. Exosomes have numerous benefits such as increasing collagen synthesis, calming inflammation, and neutralizing free radicals that can damage cells. They target injured or aging cells to restore them, meaning their benefits also extend to regeneration of hair follicles and tissues or skin rejuvenation.\nThis advancement in exosome research undoubtedly gives impetus to the evolution of aesthetic procedures and beauty, as their regenerative capabilities are proven to be greater than the capabilities of all other methods, apparatus or injections, that are available on the market at the moment.",
    shortText: "Exosomes are small vesicles from mesenchymal stem cells that exist naturally in the human body. They have the ability to stimulate regeneration, increase collagen, and calm inflammation. These innovative solutions offer more effective possibilities than traditional rejuvenation methods.",
    summaryText: "Exosomes are small vesicles from mesenchymal stem cells with regenerative properties. They increase collagen synthesis and calm inflammation. Used for rejuvenation and tissue restoration.",
    icon: "🧬"
  },
  {
    id: 2,
    title: "What makes MUSE MSC (Stem Cells) different?",
    subtitle: "MuseCells (Multi-lineage differentiating stress enduring cells) are endogenous, non-cancerous, pluripotent stem cells.",
    fullText: "These cells are found in the connective tissues of almost every organ, including umbilical cord, bone marrow, and peripheral blood. Additionally, they can be collected from commercially available mesenchymal cells such as human fibroblasts, bone marrow mesenchymal stem cells, and adipose-derived stem cells. What is intriguing about Muse Cells is their ability to generate cells representing all three germ layers from a single cell, both spontaneously and under cytokine influence. They express pluripotency genes and are characterized by their ability for triploblastic differentiation that is renewed across generations.",
    shortText: "MUSE cells are unique pluripotent stem cells found in various organs. They possess the ability to transform into cells from all three germ layers. This characteristic makes them extremely valuable for regenerative medicine.",
    summaryText: "MUSE cells are pluripotent stem cells found in various organs. They can generate cells from all three germ layers. They have enormous potential for regenerative medicine.",
    icon: "🔬"
  },
  {
    id: 3,
    title: "Exosomes extracted from Muse MSC",
    subtitle: "multilineage-differentiating stress-enduring mesenchymal stem cells",
    fullText: "They offer a revolutionary approach in the field of regenerative medicine and therapy for various diseases. Thanks to the unique ability of Muse MSC (Stem Cells) to differentiate into multiple cell lines and withstand stressful conditions, their exosomes are enriched with specific nucleic acids, proteins, lipids, and metabolites that can help restore and regenerate damaged tissues, modulate the immune system, and improve intercellular communication. This makes them particularly valuable for developing new therapeutic strategies for treating a wide spectrum of medical conditions:",
    shortText: "Exosomes from MUSE cells offer revolutionary therapeutic possibilities for multiple diseases. They contain specific bioactive molecules that restore tissues and modulate immunity. They are used for treating chronic diseases, inflammation, injuries, and anti-aging therapy.",
    summaryText: "Exosomes from MUSE cells contain bioactive molecules with therapeutic potential. They restore tissues and modulate immunity. Applied for multiple diseases and anti-aging therapy.",
    icon: "💎",
    applications: [
      "Chronic diseases",
      "Inflammatory conditions", 
      "Injuries",
      "Hair loss",
      "Skin care and anti-aging therapy"
    ]
  }
];

const MSCs = ({ language = 'bg' }) => {
  const navigate = useNavigate();
  const [expandedChunks, setExpandedChunks] = useState({});
  const [isVisible, setIsVisible] = useState({});
  
  // Use translation based on language
  const t = translations[language];
  
  // Select content chunks based on language
  const contentChunks = language === 'bg' ? bgContentChunks : enContentChunks;

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('data-chunk-id');
            setIsVisible(prev => ({ ...prev, [id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.content-chunk');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const toggleChunk = (id) => {
    setExpandedChunks(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const getContent = (chunk) => {
    if (expandedChunks[chunk.id]) {
      return <p>{chunk.shortText}</p>;
    } else {
      return (
        <>
          <p>{chunk.fullText}</p>
          {chunk.applications && (
            <div className="applications-list">
              <h4>{language === 'bg' ? 'Приложения:' : 'Applications:'}</h4>
              <ul>
                {chunk.applications.map((app, idx) => (
                  <li key={idx}>
                    <span className="check-icon">✅</span>
                    {app}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      );
    }
  };

  return (
    <div className="mscs-page">
      {/* Content Chunks */}
      <div className="content-container">
        {contentChunks.map((chunk, index) => (
          <div 
            key={chunk.id}
            className={`content-chunk ${isVisible[chunk.id] ? 'animate-in' : ''}`}
            data-chunk-id={chunk.id}
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            <div className="chunk-header">
              <div className="chunk-icon">{chunk.icon}</div>
              <div className="chunk-titles">
                <h2 className="chunk-title">{chunk.title}</h2>
                <p className="chunk-subtitle">{chunk.subtitle}</p>
              </div>
            </div>

            <div className="chunk-content">
              {getContent(chunk)}
            </div>
            
            <div className="button-group">
              <button 
                className="toggle-btn"
                onClick={() => toggleChunk(chunk.id)}
              >
                {expandedChunks[chunk.id] 
                  ? (language === 'bg' ? '📖 Пълен текст' : '📖 Full Text') 
                  : (language === 'bg' ? '📋 Кратка версия' : '📋 Brief Version')}
              </button>
            </div>
          </div>
        ))}
      </div>
      
      {/* Contact CTA */}
      <div className="contact-cta-block">
        <h3>{language === 'bg' ? 'Имате въпроси?' : 'Have questions?'}</h3>
        <p>{language === 'bg' 
           ? 'Свържете се с нас за повече информация относно мезенхимните стволови клетки' 
           : 'Contact us for more information about mesenchymal stem cells'}</p>
        <button 
          className="contact-btn"
          onClick={() => navigate('/contact')}
        >
          {language === 'bg' ? 'Свържете се с нас' : 'Contact Us'}
        </button>
      </div>
    </div>
  );
};

export default MSCs; 